import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '../../Tooltip';

const ToolbarButton = ({ name, active, code, icon, onClick, tooltip }) => (
  <Tooltip placement="top" tooltipClass="tooltip__top tooltip__wide" text={tooltip}>
    <button
      type="button"
      name={code}
      className={classNames('tiptap-toolbar__button', {
        'tiptap-toolbar__button-active': active,
      })}
      onClick={onClick}
    >
      {name || null}
      {icon && !name ? <i className={icon} /> : null}
    </button>
  </Tooltip>
)

ToolbarButton.propTypes = {
  onClick: PropTypes.func,
  name: PropTypes.string,
  icon: PropTypes.string,
  active: PropTypes.bool,
  code: PropTypes.string,
  tooltip: PropTypes.string,
};

export default ToolbarButton;
